import React from "react";
import PropTypes from "prop-types";
import { X } from "react-feather";

export const CloseIcon = ({ customClass = "", onClick, iconSize = 18 }) => {
    return (
        <div className={`x-icon ${customClass}`} onClick={onClick}>
            <X size={iconSize} />
        </div>
    );
};

CloseIcon.propTypes = {
    customClass: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    iconSize: PropTypes.number,
};

export default CloseIcon;
